































































































import Vue from 'vue';
import CurrencyInput from '@/components/CurrencyInput.vue';
import { RateCard } from '@/models/rate_card_models';
import axios from 'axios';
import SplitButton from '@/components/SplitButton.vue';

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
const NETWORK_RATE_CARDS_URL = `${BASE_URL}/rate-cards/rate-cards`;
const CUSTOMER_RATE_CARDS_URL = `${BASE_URL}/rate-cards/customer-rate-cards`;

interface CustomerRateCard {
  id?: number;
  name: string;
  networkRateCardName: string;
  hubCostPerPallet: number;
  multiPalletDiscount: number;
  headlineContribution: number;
  insuranceLevel: number;
  // Extras
  amDeliverySurcharge: number;
  timedDeliverySurcharge: number;
  saturdayAMDeliverySurcharge: number;
  tailLiftDeliverySurcharge: number;
  sameDayCollectionSurcharge: number;
  eveningDeliverySurcharge: number;
  northernIrelandImportDeclarationSurcharge: number;
  additionalNIROIHeadingsSurcharge: number;
  roiExportClearanceSurcharge: number;
  roiImportClearanceSurcharge: number;
  defermentAccountSurcharge: number;
  defermentAccountPercent: number;

  redeliverySurcharge: number;
  bookInSurcharge: number;
  handballSurcharge: number;
  attemptedCollectionSurcharge: number;
  palletAndWrapSurcharge: number;
  amazonDeliverySurcharge: number;
  notes: string;
}

export default Vue.extend({
  name: 'CustomerRateCards',
  components: { CurrencyInput, SplitButton },
  data() {
    return {
      networkRateCards: [] as RateCard[],
      networkRateCardMap: {} as { [name: string]: RateCard },
      customerRateCards: [] as CustomerRateCard[],
      loading: false,
    };
  },
  async mounted() {
    const loadNetworkRateCards = async () => {
      const response = await axios.get<{ rateCards: RateCard[] }>(NETWORK_RATE_CARDS_URL);
      this.networkRateCards = response.data.rateCards.sort((a, b) => a.name.localeCompare(b.name));
      for (const nrc of this.networkRateCards) {
        this.networkRateCardMap[nrc.name] = nrc;
      }
    };
    const loadCustomerRateCards = async () => {
      const response = await axios.get<{ rateCards: CustomerRateCard[] }>(CUSTOMER_RATE_CARDS_URL);
      this.customerRateCards = response.data.rateCards.sort((a, b) => a.name.localeCompare(b.name));
    };
    await Promise.all([loadNetworkRateCards(), loadCustomerRateCards()]);
  },
  methods: {
    addRateCard() {
      this.customerRateCards.push({
        name: '',
        networkRateCardName: this.networkRateCards[0].name,
        hubCostPerPallet: 0,
        multiPalletDiscount: 0,
        headlineContribution: 0,
        insuranceLevel: 1300,
        // Extras
        amDeliverySurcharge: 0,
        timedDeliverySurcharge: 0,
        saturdayAMDeliverySurcharge: 0,
        tailLiftDeliverySurcharge: 0,
        sameDayCollectionSurcharge: 0,
        eveningDeliverySurcharge: 0,
        northernIrelandImportDeclarationSurcharge: 0,
        additionalNIROIHeadingsSurcharge: 0,
        roiExportClearanceSurcharge: 0,
        roiImportClearanceSurcharge: 0,
        defermentAccountSurcharge: 0,
        defermentAccountPercent: 0,

        redeliverySurcharge: 0,
        bookInSurcharge: 0,
        handballSurcharge: 0,
        attemptedCollectionSurcharge: 0,
        palletAndWrapSurcharge: 0,
        amazonDeliverySurcharge: 0,
        notes: '',
      });
    },
    async saveRateCard(rc: CustomerRateCard) {
      const response = await axios.post<CustomerRateCard>(CUSTOMER_RATE_CARDS_URL, rc);
      rc.id = response.data.id;
    },
    async generatePalletwaysCSV(rc: CustomerRateCard, spacesPerLift: number) {
      try {
        this.loading = true;
        const networkRateCard = this.networkRateCardMap[rc.networkRateCardName];
        const insuranceLevel = networkRateCard.insuranceRates.find((ir) => ir.level === rc.insuranceLevel);
        const response = await axios.post(`${BASE_URL}/rate-cards/generate-palletways-csv/`, {
          ...rc,
          insuranceCharge: insuranceLevel?.costPerPallet,
          spacesPerLift,
        }, { responseType: 'arraybuffer' });
        const blob = new Blob([response.data]);
        const url = URL.createObjectURL(blob);
        const link = this.$refs.rateCardLink as HTMLAnchorElement;
        link.download = 'ratecard.csv';
        link.href = url;
        link.click();
      } finally {
        this.loading = false;
      }
    },
    async generateCustomerPDF(rc: CustomerRateCard, spacesPerLift: number) {
      try {
        this.loading = true;
        const networkRateCard = this.networkRateCardMap[rc.networkRateCardName];
        const insuranceLevel = networkRateCard.insuranceRates.find((ir) => ir.level === rc.insuranceLevel);
        const response = await axios.post(`${BASE_URL}/rate-cards/generate-customer-pdf/`, {
          ...rc,
          insuranceCharge: insuranceLevel?.costPerPallet,
          spacesPerLift,
        }, { responseType: 'arraybuffer' });
        const blob = new Blob([response.data]);
        const url = URL.createObjectURL(blob);
        const link = this.$refs.rateCardLink as HTMLAnchorElement;
        link.download = 'ratecard.pdf';
        link.href = url;
        link.click();
      } finally {
        this.loading = false;
      }
    },
  },
});
